import { stokpressViewPort } from "../util/helper";
var StellarAccordion = {};
var currentEle;
StellarAccordion.init = function () {
  StellarAccordion.process("js-btn-accordion");
  StellarAccordion.triggerCompare();
};

//add event on all btn accordion and then add class for comparison
StellarAccordion.process = function (e) {
  var eleBtn = document.getElementsByClassName(e);
  if (!eleBtn) return;
  for (var i = 0; i < eleBtn.length; i++) {
    eleBtn[i].id = "btnAccordion" + i;
    eleBtn[i].addEventListener("click", function () {
      StellarAccordion.actions(this);
    });
  }
  $(".section-accordion .collapse").on("shown.bs.collapse", function (e) {
    if (e.currentTarget) {
      var currentEle = e.currentTarget.id;
      StellarAccordion.scrollEffect(currentEle);
    }
  });
};

//toggle action
StellarAccordion.actions = function (e) {
  if (!e) return;
  currentEle = e.id;
  if (!e.classList.contains("is-active")) {
    e.classList.add("is-active");
  } else {
    e.classList.remove("is-active");
  }
  StellarAccordion.checker(e);
  StellarAccordion.triggerCompare();
};

//check btn which is active
StellarAccordion.checker = function (e) {
  //get parent of the button
  var parent = $(e).parent();
  //get direct siblings of the parent
  var siblings = $(parent).siblings();
  for (var i = 0; i < siblings.length; i++) {
    //remove is-active class
    $(siblings[i]).find(".header").removeClass("is-active");
  }
};

//scroll effect on active accordion
StellarAccordion.scrollEffect = function (e) {
  var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
  var additionalOffset = 0;
  var scrollStatus = "";
  var scrollToPosition = 0;
  var navHeight = 0;
  var isMobile = stokpressViewPort.documentWidth().width < 992;
  if ($("#js-nav-menu").length) {
    navHeight = $("#js-nav-menu").height();
    additionalOffset += navHeight;
  }
  if ($("body").hasClass("is-admin-active") && $("#wpadminbar")) {
    additionalOffset += $("#wpadminbar").height();
  }
  scrollToPosition = $("#" + e).parent().offset().top - additionalOffset;

  // if mobile, readd the height of the offset added for navbar when scrolling up since navbar hides on mobile when scrolled up.
  if (scrollToPosition > 0 && currentScroll < scrollToPosition && isMobile) {
    scrollToPosition += navHeight;
  }
  $("html, body").animate({
    scrollTop: scrollToPosition
  }, 400);
};

//once the accordion was open trigger this for flickity
StellarAccordion.triggerCompare = function () {
  if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.appVersion.indexOf("Trident/") > 0) {
    var evt = document.createEvent("UIEvents");
    evt.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(evt);
  } else {
    // window.dispatchEvent(new Event('resize'));
    setTimeout(function () {
      window.dispatchEvent(new Event("resize"));
    }, 10);
  }
};
StellarAccordion.init();
window.StellarAccordion = StellarAccordion;


// WEBPACK FOOTER //
// ./scripts/components/accordion.js